// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25p50","rootMobile":"styles_rootMobile__1DWis"};